"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$data = void 0;

var $data = function () {
  var localAPIs = {};

  localAPIs.deepAssign = function () {
    var len = arguments.length;
    if (len < 1) return;
    if (len < 2) return arguments[0];

    for (var i = 1; i < len; i++) {
      for (var key in arguments[i]) {
        if (arguments[i].hasOwnProperty(key)) {
          if (Object.prototype.toString.call(arguments[i][key]) === '[object Object]') {
            arguments[0][key] = localAPIs.deepAssign(arguments[0][key] || {}, arguments[i][key]);
          } else {
            arguments[0][key] = arguments[i][key];
          }
        }
      }
    }

    return arguments[0];
  };

  return localAPIs;
}();

exports.$data = $data;